import * as userActions from "../redux/actions/userActions";
import React from "react";
import { connect } from "react-redux";
import SubmitAnswer from "./SubmitAnswer";
import ViewPoll from "./ViewPoll";
import { useHistory, useParams } from "react-router-dom";
import Page404 from "./Page404";

function AnswerQuestion(props: { isLogged: boolean; allQuestions: { filter: (arg0: (q: any) => boolean) => [any]; }; loggedUser: { answers: {}; id: any; }; users: { filter: (arg0: (u: any) => boolean) => [any]; }; UpdateAnswered: (arg0: { author: any; selectedOption: string; questionId: any; }) => void; }) {
  const history = useHistory();
  const { questionId } = useParams() as any;
  if (props.isLogged === false) {
    return <Page404 />;
  }
  const [question] = props.allQuestions.filter((q) => q.id === questionId);
  const isAnswered = Object.keys(props.loggedUser.answers).includes(questionId);

  if (
    !question ||
    question.length === 0 ||
    !questionId ||
    questionId.length === 0
  ) {
    return <Page404 />;
  }
  const [user] = props.users.filter((u) => u.id === question.author);

  let yourVoteCircle = "";
  let yourVoteThemeOpt1 = "otherVote";
  let yourVoteThemeOpt2 = "otherVote";

  if (isAnswered === true) {
    if (question.optionOne.votes.includes(props.loggedUser.id)) {
      yourVoteCircle = "option1";
      yourVoteThemeOpt1 = "selectedVote";
    } else if (question.optionTwo.votes.includes(props.loggedUser.id)) {
      yourVoteThemeOpt2 = "selectedVote";
      yourVoteCircle = "option2";
    }
  }
  const optionOneVotes = question.optionOne.votes.length;
  const optionTwoVotes = question.optionTwo.votes.length;
  const totalVotes = optionOneVotes + optionTwoVotes;
  const opt1Ratio = ((optionOneVotes / totalVotes) * 100).toFixed(2);
  const opt2Ratio = ((optionTwoVotes / totalVotes) * 100).toFixed(2);

  function submit() {
    const opt1 = (document.getElementById("optionOne") as any).checked;
    const opt2 = (document.getElementById("optionTwo") as any).checked;
    if (opt1 === false && opt2 === false) return;
    const selectedOption = opt1 === true ? "optionOne" : "optionTwo";
    const info = {
      author: props.loggedUser.id,
      selectedOption,
      questionId,
    };

    props.UpdateAnswered(info);
    history.push(`/questions/${questionId}`);
  }

  if (isAnswered === true) {
    return (
      <ViewPoll
        params={{
          user,
          yourVoteThemeOpt1,
          yourVoteThemeOpt2,
          question,
          opt1Ratio,
          opt2Ratio,
          optionOneVotes,
          optionTwoVotes,
          totalVotes,
          yourVoteCircle,
        }}
      />
    );
  } else {
    return <SubmitAnswer user={user} question={question} submit={submit} />;
  }
}

const mapStateToProps = (state:any) => {
  return {
    allQuestions: state.questionReducer.allQuestions,
    users: state.userReducer.users,
    loggedUser: state.userReducer.loggedUser,
    isLogged: state.userReducer.loggedUser.id ? true : false,
  };
};

const mapDispatchToProps = (dispatch:any) => {
  return {
    UpdateAnswered: (info:any) => dispatch(userActions.UpdateAnswered(info)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnswerQuestion);
